import { StatsIndexDto } from "@domain";

export interface StatsRepositoryState {
  index: StatsIndexDto;
}

export const defaultStatsRepositoryState: StatsRepositoryState = {
  index: []
};
